import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const PrescriptionAlertMessage = ({ lineItems , className  })=>{
    const { getLabel  } = useIntl();
    const alertTitle = getLabel('cart.notification.rx.contactLenses.title', {
        hideLabelKey: true
    });
    const alertMsg = getLabel('cart.notification.rx.contactLenses', {
        hideLabelKey: true
    });
    const hasCLLineItems = lineItems.some((lineItem)=>lineItem.productType === 'contact-lenses'
    );
    if (!hasCLLineItems || !alertMsg) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "info",
        title: alertTitle,
        className: className
    }, alertMsg);
};

export { PrescriptionAlertMessage };
//# sourceMappingURL=PrescriptionAlertMessage.js.map
